import React from 'react';
import { courses, languages } from '../data/education';
import { Reveal } from '../components/Reveal';
import { SectionHeading } from '../components/SectionHeading';
export function Training() {
  return <section aria-labelledby="training-title" className="bg-paper py-20 md:py-28" data-id="element-362" data-mp="276kz7iu8txn0">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-363" data-mp="228syq0fj9377">
        <SectionHeading id="training-title" label="09 · Training & languages" title="Specific courses and seminars." intro="Executive and commercial training across Latin America and the United States, from strategy and finance to sales and negotiation." data-id="element-364" data-mp="22aduftdl2s6n" />

        <div className="mt-16 grid gap-14 lg:grid-cols-12" data-id="element-365" data-mp="1oes5tnb9iaer">
          <Reveal className="lg:col-span-8" data-id="element-366" data-mp="1jj4jrgs2txdh">
            <table className="w-full text-left" data-id="element-367" data-mp="1jfyua0fjcth8">
              <caption className="sr-only" data-id="element-368" data-mp="1ehnn5xgmkx2p">Courses and seminars</caption>
              <thead data-id="element-369" data-mp="1aglj93brjwue">
                <tr className="border-b border-ink text-sm text-slate-text" data-id="element-370" data-mp="1ai6e6u1zphss">
                  <th scope="col" className="pb-3 pr-6 font-medium" data-id="element-371" data-mp="3lhtd7d7pvxxf">Year</th>
                  <th scope="col" className="pb-3 pr-6 font-medium" data-id="element-372" data-mp="3q91n0acyllb4">Programme</th>
                  <th scope="col" className="hidden pb-3 font-medium sm:table-cell" data-id="element-373" data-mp="3qb4p3srdz4w7">Location</th>
                </tr>
              </thead>
              <tbody data-id="element-374" data-mp="3gip7iwk04ibu">
                {courses.map(c => <tr key={c.title} className="border-b border-line align-baseline" data-id="element-375" data-mp="3gh5lsqfktf2o">
                    <td className="whitespace-nowrap py-4 pr-6 text-sm tabular-nums text-bronze" data-id="element-376" data-mp="8484e38twybn">{c.year}</td>
                    <td className="py-4 pr-6" data-id="element-377" data-mp="d0fca1kscjw8">
                      <p className="text-base font-medium text-ink" data-id="element-378" data-mp="3v8weaf0nccwp">{c.title}</p>
                      <p className="text-xs text-slate-text" data-id="element-379" data-mp="342dipadvfum">
                        {c.type}
                        {c.location && <span className="sm:hidden" data-id="element-380" data-mp="2jspyz23upjt9"> · {c.location}</span>}
                      </p>
                    </td>
                    <td className="hidden py-4 text-sm text-slate-text sm:table-cell" data-id="element-381" data-mp="2nvchudijnueb">{c.location ?? '—'}</td>
                  </tr>)}
              </tbody>
            </table>
          </Reveal>

          <Reveal delay={0.05} className="lg:col-span-4" data-id="element-382" data-mp="pd9cn2wgwcaz">
            <div className="rounded-sm bg-ink p-8 text-paper" data-id="element-383" data-mp="kliwuhergwc6">
              <h3 className="font-serif text-2xl" data-id="element-384" data-mp="kjocb47ej68m">Languages</h3>
              <ul className="mt-6 divide-y divide-line-dark border-t border-line-dark" data-id="element-385" data-mp="fm6ea8uxabfe">
                {languages.map(l => <li key={l.name} className="py-5" data-id="element-386" data-mp="bj9pg0eshj30">
                    <p className="font-serif text-xl" data-id="element-387" data-mp="6l85zedgbhr0">{l.name}</p>
                    <p className="mt-1 text-sm text-bronze-light" data-id="element-388" data-mp="1n6kynwgt8cw">{l.level}</p>
                  </li>)}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}